<template>
  <div class="column is-12-mobile">
    <a id="buscar-fotos">
      <b-button
        type="is-success"
        href="javascript:;"
        icon-left="camera-enhance-outline"
        class="is-hidden-desktop is-fullwidth"
      >Agregar Fotos</b-button>
      <div class="is-hidden-touch" id="drop-target">
        <div class="title"></div>Presiona o arrastra tus archivos aquí
      </div>
    </a>
  </div>
</template>

<style>
#drop-target {
  border: 6px dashed #999;
  text-align: center;
  color: #999;
  font-size: 35px;
  width: 100%;
  height: 200px;
  line-height: 200px;
  cursor: pointer;
}

#drop-target.dragover {
  background: rgba(255, 255, 255, 0.4);
  border-color: green;
}
</style>

<script>
export default {
  name: 'DropTargetFotos'
}
</script>
